<template>
    <div class="progress_bar">
        <div class="company">单位：吨</div>
        <div style="left:0;position:relative;margin:0 0 .5rem;" v-for="(item,index) in dataList" :key="item.name">
            <div class="progress_bar_t"><em :class="returnStr(index)">NO.{{index+1}}</em><span>{{item.name}}</span><span class="num">{{item.val}}</span></div>
            <div class="progress_bar_box" id="div_box">
                <div ref="load" class="load" id="load">
                    <div class="load_action" v-if="item.val>0"></div>
                </div>
                <div class="load_bg"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
        }
    },
     props: {
        dataList: {
            type: Array,
            default:()=>[]
        },
    },
    mounted(){
        this.init()
    },
    methods:{
        returnStr(i){
            if(i==0) return 'one'
            else if(i==1||i==2) return 'two'
            else return ''
        },
        init(){
            this.$nextTick(()=>{
                this.dataList  = this.dataList.sort(this.sortBy('val')) 
                let max = Math.max(...this.dataList.map(e=>e.val))
                this.dataList.forEach((item,index)=>{
                    item.scale = item.val/max *10
                    this.$refs.load[index].style.width = 1.792*item.scale+'rem'
                })
            })
        },
        sortBy (field) {
            //根据传过来的字段进行排序,y-x 得分从高到低，x-y 从低到高
            return (x, y) => {
                return y[field] - x[field]
            }
        },
    },
    watch: {
    },
}
</script>
<style scoped>
    .progress_bar{
        margin: .8333rem 0 0 1.3333rem;
        position: relative;
    }
    .company{
        position: absolute;
        top: -0.8333rem;
        right: 2.0833rem;
        color: #fff;
        font-size:.5rem;
    }
    .progress_bar_t{
        font-size: .5833rem;
        display: flex;
        align-items: center;
    }
    .progress_bar_t>em{
        width: 1.75rem;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        font-size: .5833rem;
        border-radius: .2083rem;
        box-sizing: border-box;
        color: #01F7EE;
        border: .0417rem solid transparent;
        font-style:normal;
    }
    .progress_bar_t>span{
        margin-left: .8333rem;
        font-size: .6667rem;
        color: #fff;
    }
    .progress_bar_box{
            margin-top: .3333rem;
            position: relative;
            width: 17.9167rem;
            height:.1667rem;
    }
    .load{
        width:0;
        height:.1667rem;
        background:#01F7EE;
        border-radius: .4167rem;
        position: relative;
        transition: all .3s;
    }
    .load_action{
        position: absolute;
        width: .8333rem;
        height: .8333rem;
        top: 50%;
        right: -0.8333rem;
        background-image: url("../../assets/img/dian.svg");
        background-repeat: no-repeat;
        background-size: .8333rem .8333rem;
        transform: translate3d(-50%,-50%,0);
    }
    .progress_bar_t .num{
        position: absolute;
        right: 2.0833rem;
    }
    .load_bg{
        position: absolute;
        width: 100%;
        height: .125rem;
        top: 50%;
        transform: translate3d( 0 ,-50%,0);
        background: rgba(255, 255, 255, .5);
        transition: all .3s;
        border-radius: .4167rem;
    }
    .one{
        color: #000 !important;
        background: #01F7EE;
        border: .0417rem solid transparent;
    }
    .two{
        color: #fff !important;
        background: transparent;
        border: .0417rem solid #01F7EE !important;
        
    }
</style>